import api from './api';

export const userService = {
  // Get all users (admin only)
  getAllUsers: async (params = {}) => {
    try {
      const response = await api.get('/api/users', { params });
      return {
        success: true,
        data: response.data,
        message: 'Users retrieved successfully'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Failed to fetch users'
      };
    }
  },

  // Get user by ID (admin only)
  getUserById: async (id) => {
    try {
      const response = await api.get(`/api/users/${id}`);
      return {
        success: true,
        data: response.data,
        message: 'User retrieved successfully'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Failed to fetch user'
      };
    }
  },

  // Create new user (admin only)
  createUser: async (userData) => {
    try {
      const response = await api.post('/api/users', userData);
      return {
        success: true,
        data: response.data,
        message: response.data.message || 'User created successfully'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Failed to create user'
      };
    }
  },

  // Update user (admin only)
  updateUser: async (id, userData) => {
    try {
      const response = await api.put(`/api/users/${id}`, userData);
      return {
        success: true,
        data: response.data,
        message: response.data.message || 'User updated successfully'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Failed to update user'
      };
    }
  },

  // Delete user (admin only)
  deleteUser: async (id) => {
    try {
      const response = await api.delete(`/api/users/${id}`);
      return {
        success: true,
        data: response.data,
        message: response.data.message || 'User deleted successfully'
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.response?.data?.message || 'Failed to delete user'
      };
    }
  },

  // Validate user data before sending to API
  validateUserData: (userData, isUpdate = false) => {
    const errors = {};

    // Username validation
    if (!userData.username || userData.username.trim().length < 3) {
      errors.username = 'Username must be at least 3 characters long';
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!userData.email || !emailRegex.test(userData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    // Password validation (only for create, not update)
    if (!isUpdate && (!userData.password || userData.password.length < 6)) {
      errors.password = 'Password must be at least 6 characters long';
    }

    // Role validation
    if (!userData.role || !['admin', 'user'].includes(userData.role)) {
      errors.role = 'Please select a valid role';
    }

    // Language validation
    if (userData.language && !['en', 'es'].includes(userData.language)) {
      errors.language = 'Please select a valid language';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};

